let db = {
  save (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get (key, defaultValue = {}) {
    // 如果是language，则默认值定义为中文
    if (key === 'language') defaultValue = '"zh-cn"'
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : defaultValue
  },
  remove (key) {
    localStorage.removeItem(key)
  },
  clear () {
    let language = localStorage.getItem('language') || '"zh-cn"'
    let hideCompanyInfo = localStorage.getItem('Hide_Company_Info') || ''
    localStorage.clear()
    localStorage.setItem('language', language)
    localStorage.setItem('Hide_Company_Info', hideCompanyInfo)
  }
}

export default db



// WEBPACK FOOTER //
// ./src/utils/localstorage.js